<template>
  <b-row>
    <b-col cols="12" class="mb-1">
      <h3 class="mb-0">
        รายละเอียดการร้องทุกข์
      </h3>
    </b-col>

    <b-col cols="12">
      <b-form-group label="รายละเอียดเรื่องร้องทุกข์">
        <!-- <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียด เพื่อความรวดเร็วในการดำเนินการของเจ้าหน้าที่</span> -->
        <b-form-textarea
          v-model="company.complaintDetail"
          placeholder="รายละเอียดเรื่องร้องทุกข์"
          :v-text="selected"
          :readonly="!isEdit"
          rows="10"
        />
      </b-form-group>
    </b-col>

    <div
      v-for="value in complaintDetail"
      :key="value.description"
      class="col-12"
    >
      <div class="mt-2">
        <h4 class="">
          {{ value.description }}
        </h4>
        <div v-if="value.masterTypeId == 6">
          <b-row>
            <b-col
              v-for="(header, index) in complaintDetail[0].tmMasterList"
              :key="index"
              cols="12"
            >
              <div v-if="header.checked == true" class="mt-1">
                <div>-หมวดหมู่เรื่องร้องทุกข์ {{ header.description }}</div>
                <b-row>
                  <b-col
                    v-for="(box, index) in value.tmMasterList.filter((obj) => {
                      return obj.refMasterId === header.masterId;
                    })"
                    :key="index"
                    cols="4"
                    class="mt-1"
                  >
                    <b-form-checkbox
                      :disabled="IsReadOnly"
                      :key="index"
                      v-model="box.checked"
                      @change="checkboxChanged(box)"
                    >
                      {{ box.description }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-row>
            <b-col
              v-for="(box, index) in value.tmMasterList"
              :key="index"
              cols="4"
              class="mt-1"
            >
              <b-form-checkbox
                :disabled="IsReadOnly"
                :key="index"
                v-model="box.checked"
                @change="checkboxChanged(box)"
              >
                {{ box.description }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>
        <b-col cols="12">
          <hr />
        </b-col>
      </div>
    </div>

    <div
      v-for="value in complaintDetailMultiSelect"
      :key="value.description"
      class="col-12"
    >
      <div class="mt-2">
        <h4 class="">
          {{ value.description }}
        </h4>
        <b-row>
          <!--v-if="value.tmMasterList != null"  handle ตอนโหลดข้อมูล-->
          <b-col v-if="value.tmMasterList != null" cols="12" class="mt-1">
            <multiselect
              :disabled="true"
              v-model="value.tmMasterListSelected"
              track-by="description"
              label="description"
              :options="value.tmMasterList"
              :multiple="true"
            >
            </multiselect>
          </b-col>
        </b-row>

        <b-row v-if="value.tmMasterListSelected !== null">
          <b-col
            cols="6"
            class="mt-1"
            v-for="item in value.tmMasterListSelected.filter(
              (f) => f.masterId === 498 || f.masterId === 499
            )"
            :key="item.masterId"
          >
          <!-- จะไม่เเสดงจำนวนเงิน กรณีเป็นคำร้องเก่าที่ ต้องการเรียกร้องค่าเสียหาย หรือ ต้องการเงินคืน -->
          <span v-if="item.amount != null || item.amount != undefined">
            <span>
              {{ item.description + " (บาท) " }}
              <!-- <small class="text-danger text-small">
                **โปรดระบุจำนวนเงินเป็นตัวเลขเท่านั้น</small
              > -->
            </span>
            <b-form-input
              v-model="item.amount"
              placeholder="กรุณาใส่จำนวนเงิน (บาท)"
              type="number"
              :disabled="true"
            />
            <!-- <span
              :ref="`spanMaster_${item.masterId}`"
              :id="`spanMaster_${item.masterId}`"
              class="mt-1 text-danger text-small"
            ></span> -->
            </span>
          </b-col>
          <b-col
            cols="12"
            v-if="value.tmMasterListSelected.some(
              f => (f.masterId === 498 || f.masterId === 499) && (f.amount === null || f.amount === undefined)
            )"
          >
            <!-- จะไม่เเสดงจำนวนเงิน กรณีเป็นคำร้องเก่าที่ ต้องการเรียกร้องค่าเสียหาย หรือ ต้องการเงินคืน -->
              <span class="text-danger">
              **หมายเหตุ เป็นเเรื่องร้องทุกข์เดิมที่ไม่มีการบันทึกจำนวนเงิน
            </span>
          </b-col>
        </b-row>

        <b-row
          v-for="value2 in complaintCatagoryDetail"
          :key="value2.catagoryDeId + value2.masterTypeId"
        >
          <b-col
            v-if="value.masterTypeId == value2.masterTypeId"
            cols="12"
            class="mt-1"
          >
            <b-form-group label="รายละเอียดเพิ่มเติม">
              <b-form-input
                v-model="value2.description"
                :value="value2.description"
                :disabled="true"
                class="col-12"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-col cols="12">
          <hr />
        </b-col>
      </div>
    </div>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
} from "bootstrap-vue";
import CustomSelectGroup from "./CustomSelectGroup.vue";
import CustomRadioGroup from "./CustomRadioGroup.vue";

import * as ComplaintAPI from "@/store/api/complaint/complaint.js";

import Multiselect from "vue-multiselect";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BCardText,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    CustomSelectGroup,
    CustomRadioGroup,
    ComplaintAPI,
    Multiselect,
  },
  props: {
    IsReadOnly: Boolean,
    complaintDetail: {
      type: Array,
    },
    complaintCatagoryDetail: {
      type: Array,
      default: [],
    },
    complaintDetailMultiSelect: {
      type: Array,
      default: [],
    },
    company: {
      type: Object,
      required: true,
    },
  },
  created() {
    // `this` points to the vm instance
    // console.log(`a is: ${this.a}`)
    // console.log('this complaintSubjectSelects', this.complaintSubjectSelects)
  },
  methods: {
    checkboxChanged(obj) {
      //console.log("checkboxChangedIn: ", obj)
      console.log("multiselectedChanged: ", this.complaintDetailMultiSelect);
      this.$emit("checkboxChanged", obj);
    },
    multiselectedChanged(obj) {
      //console.log("multiselectedChanged: ", obj)
    },
    refreshPage() {
      //call from root
      this.$forceUpdate();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
